'use client';
import {
  Dialog,
  DialogBody,
  DialogHeader,
  IconButton,
} from '@material-tailwind/react';
import React from 'react';
import { BaseTranslations } from '../../../baseTranslations';
import { useCmsClientContext } from '../../../utils/cmsPageContext/useCmsClientContext';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import Close from '../../icons/Close';
import { MaterialIcon } from '../../MaterialIcon';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onTryAgain: () => void;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  onClose,
  onTryAgain,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);

  return (
    <Dialog
      open={isOpen}
      handler={onClose}
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
      className="rounded-3xl p-0 shadow-lg sm:p-4 md:!w-100 lg:!w-[800px]"
    >
      <DialogHeader className="flex justify-end p-0">
        <IconButton
          variant="text"
          className="flex size-6 items-center justify-center text-gray-900"
          onClick={onClose}
        >
          <Close className="flex size-6 text-gray-900" />
        </IconButton>
      </DialogHeader>
      <DialogBody className="px-0 sm:py-0 lg:pb-20 lg:pt-8">
        <div className="lg:mx-auto lg:w-100">
          <div className="flex flex-col items-center justify-center sm:gap-2 lg:gap-4">
            <div className="flex items-center justify-center rounded-full bg-red-light sm:size-22 md:size-26 lg:size-32">
              <MaterialIcon
                icon="warning"
                // eslint-disable-next-line tailwindcss/no-arbitrary-value
                className="text-highlights/red-dark sm:text-[50px] md:text-[62px] lg:text-[74px]"
              />
            </div>
            <h2 className="text-center font-bold text-gray-900 sm:text-xl md:text-2xl lg:text-3xl">
              {staticText.error_modal_title}
            </h2>
            <p className="text-center font-medium text-gray-800 sm:text-lg md:text-lg">
              {staticText.error_modal_subtitle}
            </p>
          </div>
          <div className="mt-6 sm:h-9 md:h-10 lg:h-12">
            <button
              type="button"
              className="size-full rounded-xl font-semibold bg-primary-800 text-white sm:text-base md:text-lg lg:text-xl"
              onClick={onTryAgain}
            >
              {staticText.try_again}
            </button>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
};
